import universal from 'react-universal-component';

export default universal(() => import('./FiltersHeader'));



// WEBPACK FOOTER //
// ./src/app/components/FiltersHeader/index.js